import React from "react";

const SVGComponent = ({ color }) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M29.1875 3.8125H2.8125C1.26363 3.8125 0 5.07475 0 6.625V25.375C0 26.92 1.258 28.1875 2.8125 28.1875H29.1875C30.7325 28.1875 32 26.9295 32 25.375V6.625C32 5.08 30.742 3.8125 29.1875 3.8125ZM28.7991 5.6875L16.0596 18.4271L3.20994 5.6875H28.7991ZM1.875 24.9867V7.00431L10.9049 15.9568L1.875 24.9867ZM3.20081 26.3125L12.2364 17.2769L15.4025 20.4158C15.769 20.7791 16.3604 20.7779 16.7254 20.4129L19.8125 17.3258L28.7992 26.3125H3.20081ZM30.125 24.9867L21.1383 16L30.125 7.01325V24.9867Z" fill="#B90162"/>
</svg>


);

export default SVGComponent;
